import React, { FC } from 'react';

import { IconPropsExtended } from '../types';

import MaterialSymbolIconBase from './MaterialSymbolIconBase';

/**
 * Material symbol folderNew icon
 *
 * @param props Props passed to the component
 * @returns     FolderNew icon
 */
const MaterialSymbolFolderNewIcon: FC<IconPropsExtended> = props => (
  <MaterialSymbolIconBase {...props} iconName="folderNew" />
);

export default MaterialSymbolFolderNewIcon;
